import { library } from "@fortawesome/fontawesome-svg-core";

import { fas } from "@fortawesome/free-solid-svg-icons";

import { fab } from "@fortawesome/free-brands-svg-icons";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
library.add(fas, fab as any);
